import $ from 'jquery';
import Swiper from 'swiper/bundle';

// init Swiper:
const leistung_swiper = new Swiper('.leistung-swiper', {

    freeMode: false,
    direction: "horizontal",
    mousewheel: true,
    forceToAxis: true,
    slidesPerView: 1.2,
    spaceBetween: 30,
    loop: false,

    scrollbar: {
        el: ".swiper-scrollbar",
        hide: false,
    },

    breakpoints: {
        640: {
            slidesPerView: 2.4,
            freeMode: true,
        },
    },
});



// WEBPACK FOOTER //
// ./wp/wp-content/themes/brockmeyer-chisel/src/scripts/additional/leistung-swiper.js